export const INITIALIZE_ACTION = 'app/DocAndSignatureView/INITIALIZE_ACTION';
export const SHOW_MODAL_ACTION = 'app/DocAndSignatureView/SHOW_MODAL_ACTION';
export const ACCEPT_CONDITIONS_ACTION = 'app/DocAndSignatureView/ACCEPT_CONDITIONS_ACTION';
export const SET_CODE_ACTION = 'app/DocAndSignatureView/SET_CODE_ACTION';
export const IS_VALID_CONTRACT_ACTION = 'app/DocAndSignatureView/IS_VALID_CONTRACT_ACTION';
export const RENEWED_PIN_ACTION = 'app/DocAndSignatureView/RENEWED_PIN_ACTION';
export const IS_PDF_RENDER = 'app/DocAndSignatureView/IS_PDF_RENDER';
export const CANCEL_UPLOAD_ACTION = 'app/DocAndSignatureView/CANCEL_UPLOAD_ACTION';
